import { useMemo } from "react";
import ProductCard from "@/pages/home/components/ProductCard";
import type { ProductItem } from "@/lib/supabase";
import { useVariantsByProductIds } from "@/hooks/useProducts";

interface RelatedProductsProps {
  products: ProductItem[];
}

export default function RelatedProducts({ products }: RelatedProductsProps) {
  const productIds = useMemo(() => products.map((p) => p.id), [products]);
  const { variantsByProduct } = useVariantsByProductIds(productIds);

  return (
    <section className="w-full bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="flex items-end justify-between mb-6 md:mb-8">
          <div>
            <p className="text-[12px] uppercase tracking-[0.18em] text-foreground-600 mb-2">
              Você também pode gostar
            </p>
            <h2 className="font-heading text-foreground-950 text-2xl md:text-3xl font-medium">
              Mais da mesma coleção
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {products.map((p) => (
            <ProductCard
              key={p.id}
              product={p}
              variants={variantsByProduct[p.id] ?? []}
            />
          ))}
        </div>
      </div>
    </section>
  );
}